import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: '¡Felicidades! Has ganado {{amount}} en cashback.',
  },
};
